import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { getUserCommercialLink, getUserSellersToChoose } from 'domains/user';
import { useFetchSellers } from 'domains/user/User.requests';
import { CenteredSpin, Flex } from 'UI';
import { getData } from 'utils';
import SellerCard from './SellerCard';
import { DataContainer } from '../DataContainer';

const Sellers = () => {
  const commercialLink = useSelector(getUserCommercialLink);
  const currentSeller = commercialLink?.seller;
  const sellersToChooseFrom = useSelector(getUserSellersToChoose);
  const [selectedSeller, setSelectedSeller] = useState(currentSeller);

  useFetchSellers();

  return (
    <DataContainer data={sellersToChooseFrom} Loading={() => <CenteredSpin size={'large'} />}>
      <Flex gap={27} wrap={'wrap'}>
        {getData(sellersToChooseFrom)?.map((seller) => (
          <SellerCard
            key={seller.id}
            seller={seller}
            activeSeller={selectedSeller?.id === seller.id}
            setSelectedSeller={setSelectedSeller}
          />
        ))}
      </Flex>
    </DataContainer>
  );
};

export default Sellers;
